var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "0%",
    x2: "92.2525491%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.5901575%",
    y1: "0%",
    x2: "65.4112471%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.5863131%",
    y1: "0%",
    x2: "65.4153587%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "29.9981705%",
    y1: "0%",
    x2: "71.3918464%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.0194944%",
    y1: "0%",
    x2: "71.3690406%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "13.7166482%",
    y1: "0%",
    x2: "88.8048447%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "13.7069681%",
    y1: "0%",
    x2: "88.8151975%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "staker---staking-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-6",
    transform: "translate(-299.000000, -152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cosmos-logo-horizontal-dark",
    transform: "translate(300.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9999365,0 C58.9867462,0 76,17.0131586 76,37.9999365 C76,58.9867462 58.9867462,76 37.9999365,76 C17.0131586,76 0,58.9867462 0,37.9999365 C0,17.0131586 17.0131586,0 37.9999365,0 Z",
    id: "Path",
    strokeOpacity: 0.2,
    stroke: "#00F3AB",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eth-crypto-cryptocurrency-cryptocurrencies-cash-money-bank-payment_95451",
    transform: "translate(22.000000, 12.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-2)",
    points: "15.9957333 0 15.9957333 19.222338 31.9893333 26.4821838"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    points: "15.9957333 0 0 26.4821838 15.9957333 19.222338"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    points: "15.9957333 38.9387789 15.9957333 52 32 29.5074807"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-5)",
    points: "15.9957333 52 15.9957333 38.9366118 0 29.5074807"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-6)",
    points: "15.9957333 35.9156491 31.9893333 26.4821838 15.9957333 19.2266722"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-7)",
    points: "0 26.4821838 15.9957333 35.9156491 15.9957333 19.2266722"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.3fb30df368786e533f3d766b62904e70.svg";
export { ForwardRef as ReactComponent };